import React, { useState } from "react";
import LocationInput from "../LocationInput";
import { Box, Divider } from "@mui/material";
import PlacesAutocomplete from "shared/GoogleAutoComplete/PlacesAutocomplete";
const StaySearchForm = (props: any) => {
  const { activity, setActivity, setSelectedDate, selectedDate } = props;
  const [selectedPlace, setSelectedPlace] = useState<string>("company");
  const [selectedArea, setSelectedArea] = useState<string>("athens");
  const [period, setPeriod] = useState<string>("savvatokuriako");

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ mb: 2 }}>
        <LocationInput
          onChange={(value) => {
            setActivity(value);
          }}
        />
      </Box>
      
      <Box>
        <PlacesAutocomplete 
            setCoordinates={props?.setCordinates}
                  placeholder={activity === "party" 
                    ? "Αναζήτησε πάρτυ με βάση την τοποθεσία" 
                    : "Αναζήτησε εξόδους με παιδιά"} 
                />
      </Box>
    </Box>
  );
};

export default StaySearchForm;
